import { REACT_APP_API_BASE_URL, REACT_APP_API_PRINCIPAL_URL } from '../config/settings/environment'
import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'

import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets a organization by the given identifier.
 */
export const getSupplierSkillCaculation = factoryService(({ orgTaxID }) => {
  const dni = normalizeDniSlashes(orgTaxID)

  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/info-habilidad/${dni}`)
})

/**
 * Gets a prioritized provider based on the given identifier.
 */
export const getPrioritizedSupplier = factoryService(({ orgTaxID }) => {
  const dni = normalizeDniSlashes(orgTaxID)

  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/proveedor/empresa/${dni}`)
})

/**
 * Gets lowest value to offers.
 */
export const getLowestValueOffer = factoryService(({ idCa, idOffer }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/solicitud/${idCa}/${idOffer}`)
)

/**
 * Gets provider information about hability.
 */
export const getSupplierHability = factoryService(({ orgTaxID, isForeign }) => {
  const dni = normalizeDniSlashes(orgTaxID)

  return getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v3/proveedor/habilidad/${dni}/${isForeign}`)
})
